// From mustache.js https://github.com/janl/mustache.js/blob/master/mustache.js#L60
// Copyright (c) 2009 Chris Wanstrath (Ruby)
// Copyright (c) 2010-2014 Jan Lehnardt (JavaScript)
// Copyright (c) 2010-2015 The mustache.js community
// Mustache license: https://github.com/janl/mustache.js/blob/master/LICENSE

// Ported to typescript by Tim Hambourger (c) 2017

const entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;',
  '`': '&#x60;',
  '=': '&#x3D;'
} as { [key : string] : string };

const TO_ESCAPE = /[&<>"'`=\/]/g;

function fromEntityMap(s : string) {
  return entityMap[s];
}

export default function escapeHtml(string : string) {
  return string.replace(TO_ESCAPE, fromEntityMap);
}



// WEBPACK FOOTER //
// ./lib/escapeHtml.ts